export const returnTabs = {
  REQUEST_RETURN: 0,
  RETURN_ACCEPTED: 1,
  //   AssignedToTeam: 4,
  // AssignedToDriver: 5,
  // OrderAcceptedByDriver: 6,
  // ReachedPickupLocation: 7,
  // OrderPickedUp: 8,
  // OnTheWay: 9,
  // Delivered: 10,
  // RETURN_REJECTED: 11
  AssignedToTeam: 2,
  AssignedToDriver: 3,
  OrderAcceptedByDriver: 4,
  ReachedPickupLocation: 5,
  OrderPickedUp: 6,
  OnTheWay: 7,
  Delivered: 8,
  RETURN_REJECTED: 9,
  QualityCheck: 10
};
